export default "__VITE_ASSET__CczF2thB__"